import { selectDoesUserHaveRbacPermission } from 'core/userContext';
import { useSelector } from 'react-redux';

import { SecondaryButton } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { ListSubscribe } from 'ui/icons/events';
import { BUTTON_SIZES } from 'ui/button/constants';
import { PROJECT_PERMISSIONS } from 'utils/permissions';

import { useListModalContext } from '../context/ListModalContext';

const displayContent = {
  label: 'Add to existing list',
  tooltip: 'You do not have permission to add users to lists',
};

export const AddMenu = () => {
  const { showListModalOptions } = useListModalContext();
  const canEditLists = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.ManageSegmentation,
  );

  return (
    <Tooltip tooltipContent={displayContent.tooltip} isEnabled={!canEditLists}>
      <SecondaryButton
        onClick={() => {
          showListModalOptions({
            toList: true,
          });
        }}
        size={BUTTON_SIZES.LARGE}
        isDisabled={!canEditLists}
      >
        <ListSubscribe />
        <span data-test="list-subscribe-menu">{displayContent.label}</span>
      </SecondaryButton>
    </Tooltip>
  );
};
